@let loading = loading$ | async;
@let error = error$ | async;
@let passwordVisible = passwordVisible$ | async;
@let repeatVisible = repeatVisible$ | async;
@let changed = changed$ | async;
@let user = data.user;
@let roles = roles$ | async;

<header class="rms-dialog-header">
  <div class="rms-dialog-header-content">
    <h3 class="rms-dialog-header-content-title">
      {{ (user ? "partners.users.edit.title-edit" : "partners.users.edit.title-create") | translate }}
    </h3>
  </div>
  <rms-close-button mat-dialog-close />
</header>

<div class="flex flex-col gap-2">
  @if (error) {
    <rms-toast
      icon="remix:System/error-warning-fill"
      color="ochraceus"
      [message]="error" />
  }

  <form
    class="flex flex-col gap-4"
    [formGroup]="form"
    (ngSubmit)="submit()">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div class="form-control">
        <label for="first-name">{{ "partners.users.edit.form.first-name.label" | translate }}</label>
        <mat-form-field subscriptSizing="dynamic">
          <input
            id="first-name"
            type="text"
            matInput
            formControlName="first_name"
            autocomplete="off"
            rmsControlError />
        </mat-form-field>
      </div>

      <div class="form-control">
        <label for="last-name">{{ "partners.users.edit.form.last-name.label" | translate }}</label>
        <mat-form-field subscriptSizing="dynamic">
          <input
            id="last-name"
            type="text"
            matInput
            formControlName="last_name"
            autocomplete="off"
            rmsControlError />
        </mat-form-field>
      </div>
    </div>

    <div class="form-control">
      <label for="email">{{ "partners.users.edit.form.email.label" | translate }}</label>
      <mat-form-field subscriptSizing="dynamic">
        <input
          id="email"
          type="email"
          matInput
          formControlName="email"
          autocomplete="off"
          rmsControlError
          [placeholder]="'partners.users.edit.form.email.placeholder' | translate" />
      </mat-form-field>
    </div>

    <div class="form-control">
      <label for="phone-number">{{ "partners.users.edit.form.phone-number.label" | translate }}</label>
      <rms-phone-input
        id="phone-number"
        formControlName="phone_number"
        rmsControlError
        [defaultCountryCode]="phoneDefaultCountry" />
    </div>

    @if (!user) {
      <div class="form-control">
        <label
          id="role-label"
          for="role">
          {{ "partners.users.edit.form.role.label" | translate }}
        </label>
        <mat-form-field subscriptSizing="dynamic">
          <mat-select
            id="role"
            aria-labelledby="role-label"
            formControlName="role">
            @for (option of roles; track option.id) {
              <mat-option [value]="option.id">{{ roleLabels[option.name] | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-control">
        <label for="password">{{ "partners.users.edit.form.password.label" | translate }}</label>
        <mat-form-field subscriptSizing="dynamic">
          <input
            id="password"
            class="[&::-ms-reveal]:hidden [&::-ms-clear]:hidden"
            matInput
            [type]="passwordVisible ? 'text' : 'password'"
            formControlName="password"
            autocomplete="new-password"
            rmsControlError />
          <button
            type="button"
            mat-icon-button
            matSuffix
            [attr.aria-label]="
              (passwordVisible ? 'auth.controls.hide-password' : 'auth.controls.show-password') | translate
            "
            (click)="passwordVisible$.next(!passwordVisible)">
            <mat-icon [svgIcon]="passwordVisible ? 'remix:System/eye-line' : 'remix:System/eye-off-line'" />
          </button>
        </mat-form-field>
      </div>

      <div class="form-control">
        <label for="repeat">{{ "auth.controls.repeat-password.label" | translate }}</label>
        <mat-form-field subscriptSizing="dynamic">
          <input
            id="repeat"
            class="[&::-ms-reveal]:hidden [&::-ms-clear]:hidden"
            matInput
            [type]="repeatVisible ? 'text' : 'password'"
            formControlName="repeat"
            autocomplete="new-password"
            rmsControlError />
          <button
            type="button"
            mat-icon-button
            matSuffix
            [attr.aria-label]="
              (repeatVisible ? 'auth.controls.hide-password' : 'auth.controls.show-password') | translate
            "
            (click)="repeatVisible$.next(!repeatVisible)">
            <mat-icon [svgIcon]="repeatVisible ? 'remix:System/eye-line' : 'remix:System/eye-off-line'" />
          </button>
        </mat-form-field>
      </div>
    }

    <div class="rms-dialog-actions">
      <button
        type="button"
        class="rms-dialog-actions-button"
        mat-button
        mat-dialog-close>
        {{ "libs.common.cancel" | translate }}
      </button>
      <button
        type="submit"
        color="primary"
        class="rms-dialog-actions-button"
        mat-raised-button
        [disabled]="form.invalid || loading || !changed">
        @if (loading) {
          <mat-progress-spinner
            class="stroke-white"
            mode="indeterminate"
            [diameter]="30" />
        } @else {
          {{ (user ? "partners.users.edit.form.submit-edit" : "partners.users.edit.form.submit-create") | translate }}
        }
      </button>
    </div>
  </form>
</div>
